import { toast } from "sonner";
export async function getTimeValue() {
    try {
        const url = `${process.env.REACT_APP_API_URL}/admin/profesor/valorhora/ValoresTiempo`;
        const token = sessionStorage.getItem('token'); // Retrieve the JWT token from session storage
        const resp = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
                'Content-Type': 'application/json'
            }
        });
        const data = await resp.json();
        const timeValuesList = data.map((item) => ({
            id: item.id,
            name: item.name,
            virtualHourValue: item.virtualHourValue,
            inpersonHourValue: item.inpersonHourValue,
            virtualHourCancelledValue: item.virtualHourCancelledValue || 0,
            inpersonHourCancelledValue: item.inpersonHourCancelledValue || 0
        }));
        return timeValuesList;
    } catch (error) {
        toast.error('Error al obtener las nominas de los profesores', error.message);
        console.error('Error al obtener nominas profesores:', error);
        throw error;
    }
};
